import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';


// Other module imports
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ToastrModule } from 'ngx-toastr';
import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { rootReducer } from './modals';
import { AuthenticationEffects } from './modals/Authentication/authentication.effects';
import { routes } from './app.routes';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { BsDropdownConfig } from 'ngx-bootstrap/dropdown';
import { CustomToastComponent } from './shared/custom-toast/custom-toast.component';
import { ProfileEffect } from './modals/Profile/profile.effects';
import { RolesRecordEffects } from './modals/Roles/roles.effect';
import { DatePipe } from '@angular/common';
import { AccessRecordEffects } from './modals/Access/access.effect';
import { ManualssRecordEffects } from './modals/Manuals/manuals.effect';
import { ChangelogsRecordEffects } from './modals/Changelogs/changelogs.effect';
import { FaqsRecordEffects } from './modals/Faqs/faqs.effect';
import { SupportRequestsRecordEffects } from './modals/SupportRequests/support-requests.effect';
import { ChangelogVersionsRecordEffects } from './modals/ChangelogVersions/changelog-versions.effect';
import { ClubsRecordEffects } from './modals/Clubs/clubs.effect';
import { TaskboardRecordEffects } from './modals/Taskboard/taskboard.effect';
import { DossierRecordEffects } from './modals/Dossier/dossier.effect';
import { DossierAttachmentRecordEffects } from './modals/DossierAttachment/dossier-attachment.effect';
import { UsersRecordEffects } from './modals/Users/users.effect';
import { provideServiceWorker } from '@angular/service-worker';
import { SentCorrespondencesRecordEffects } from './modals/SentCorrespondence/sent-correspondence.effect';
import { MemberRecordEffects } from './modals/Member/member.effect';
import { MemberAttachmentRecordEffects } from './modals/MemberAttachment/member-attachment.effect';
import { DashboardRecordEffects } from './modals/Dashboard/dashboard.effect';
import { MutationRecordEffects } from './modals/Mutation/mutation.effect';
import { ReportRecordEffects } from './modals/Report/report.effect';
import { PaymentsBatchRecordEffects } from './modals/PaymentsBatch/payments-batch.effect';
import { PaymentsRecordEffects } from './modals/Payments/payments.effect';
import { DossierInvoicesRecordEffects } from './modals/DossierInvoice/dossier-invoice.effect';
import { PaymentGatewayRecordEffects } from './modals/PaymentGateway/payment-gateway.effect';
import { PaymentArrangementRecordEffects } from './modals/PaymentArrangement/payment-arrangement.effect';

export function createTranslateLoader(http: HttpClient): any {
  return new TranslateHttpLoader(http, 'fetch-lang/client_', '.json');
}

export const appConfig: ApplicationConfig = {
  
  providers: [
    DatePipe,
    provideZoneChangeDetection({ eventCoalescing: true }), 
    provideRouter(routes),
    provideStore(rootReducer),
    provideEffects(
      [
        AuthenticationEffects,
        RolesRecordEffects,
        AccessRecordEffects,
        ProfileEffect,
        ManualssRecordEffects,
        ChangelogsRecordEffects,
        FaqsRecordEffects,
        SupportRequestsRecordEffects,
        ChangelogVersionsRecordEffects,
        ClubsRecordEffects,
        TaskboardRecordEffects,
        DossierRecordEffects,
        DossierAttachmentRecordEffects,
        UsersRecordEffects,
        SentCorrespondencesRecordEffects,
        MemberRecordEffects,
        MemberAttachmentRecordEffects,
        DashboardRecordEffects,
        MutationRecordEffects,
        ReportRecordEffects,
        PaymentsBatchRecordEffects,
        PaymentsRecordEffects,
        DossierInvoicesRecordEffects,
        PaymentGatewayRecordEffects,
        PaymentArrangementRecordEffects
      ]
    ),
    provideHttpClient(withInterceptorsFromDi()),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: createTranslateLoader,
          deps: [HttpClient]
        }
      }),
      ToastrModule.forRoot({
        toastComponent: CustomToastComponent
      }),
    ),
    provideAnimations(),
    // provideToastr(),
    { provide: BsDropdownConfig, useValue: { isAnimated: true, autoClose: true } },
    // provideServiceWorker('ngsw-worker.js')
    // provideServiceWorker('combined-sw.js')
  ]
};

